import React, { useEffect, useState } from "react";
import "./style.scss";
import { queryAuthPackSingle } from "utils/api";

export default function PermissionDetail(props) {
  const { authPackId, appKey } = props;
  const [infoList, setInfoList] = useState([]);
  useEffect(() => {
    queryAuthPackSingle({
      appKey: appKey,
      authPackId: authPackId,
    }).then((res) => {
      if (res.data.success && res.data.result.apiGroupList !== undefined) {
        setInfoList(res.data.result.apiGroupList);
      }
    });
  }, [appKey, authPackId]);

  return (
    <div className="permisson_detail">
      {infoList.length > 0
        ? infoList.map((item, index) => {
            return (
              <div className="detail_group" key={index + "infoList"}>
                <div className="group_title">
                  {item.apiGroupName}（{item.authApiInfoList.length}项）
                </div>
                <div className="group_content">
                  {item.authApiInfoList.map((sitem, sindex) => {
                    return (
                      <div
                        className="content_item"
                        key={sindex + "authApiInfoList"}
                      >
                        <span className="item_index">{sindex + 1}</span>
                        <span>{sitem.apiCnName}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })
        : ""}
    </div>
  );
}
